import { ApiResponse } from "@/types/apiTypes";
import { modelDocType, model_type } from "@/types/models";
import { createApi } from "@reduxjs/toolkit/query/react";
import { normalBaseQuery } from "../BaseQuery";

export type ReturnedExcelData = {
  created_at: Date;
  doc_count: number;
  doc_link: string;
  mapper: Record<string, string>;
  model_type: model_type;
  name: string;
  _id: string;
  name_overrides?: { original: string; override: string }[];
  operation_config?: {
    mode: string;
    arrayStrategy: Record<string, string>;
  };
};

export const excelDocApi = createApi({
  reducerPath: "excelDocApi",
  baseQuery: normalBaseQuery,
  tagTypes: ["ExcelDocList"],
  endpoints: (builder) => ({
    createExcelDoc: builder.mutation<ApiResponse<any>, modelDocType>({
      query: (data) => ({
        url: "admin/excel/",
        method: "POST",
        body: { doc: data },
      }),
      invalidatesTags: ["ExcelDocList"],
    }),
    deleteExcelDoc: builder.mutation<ApiResponse<any>, { id: string }>({
      query: ({ id }) => ({
        url: `admin/excel/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["ExcelDocList"],
    }),
    getExcelDocList: builder.query<ApiResponse<ReturnedExcelData[]>, void>({
      providesTags: ["ExcelDocList"],
      query: () => ({
        url: "admin/excel/",
        method: "GET",
      }),
    }),
    getExcelDoc: builder.query<ApiResponse<ReturnedExcelData>, { id: string }>({
      query: ({ id }) => ({
        url: `admin/excel/${id}/`,
        method: "GET",
      }),
    }),
    updateDoc: builder.mutation<ApiResponse<any>, { id: string; num: number }>({
      query: ({ id, num }) => ({
        url: `admin/excel/${id}/`,
        method: "PUT",
        body: {
          num,
        },
      }),
    }),
    saveDraft: builder.mutation<
      ApiResponse<ReturnedExcelData>,
      {
        id: string;
        name_overrides?: { original: string; override: string }[];
        operation_config?: { mode: string; arrayStrategy: Record<string, string> };
      }
    >({
      query: ({ id, ...body }) => ({
        url: `admin/excel/${id}/draft`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["ExcelDocList"],
    }),
  }),
});

export const {
  useCreateExcelDocMutation,
  useGetExcelDocListQuery,
  useGetExcelDocQuery,
  useUpdateDocMutation,
  useDeleteExcelDocMutation,
  useSaveDraftMutation,
} = excelDocApi;
